/* @flow */
import React from 'react';
// $FlowIgnore
import { connect } from 'react-redux';
// $FlowIgnore
import moment from 'moment';
// $FlowIgnore
import './style.css';
import { api } from 'utils/ajax';
import { Td, Tr } from 'components/UIKit/Table';
import Button from 'components/UIKit/Button/Button';
import Spinner from 'components/UIKit/Spinner/Spinner';
import ParamsLink from 'components/Links/ParamsLink';
import TransactionIcon from 'components/icons/TransactionIcon';
import DATE_FORMAT from 'constants/date';
import { showOptimisticPendingTransaction, fetchUploadTransactions } from 'ducks/uploadTransactions';
import type { Transaction } from 'models/transactions';

type TransactionsRowProps = {
  router: Object,
  children: Transaction,
  i: number,
  dispatch: () => {},
  projectInReview: boolean,
}

function UploadTransactionsRow({
  children, router, i, dispatch, projectInReview
}: TransactionsRowProps): React.Element {
  let newQuery = {did: children.id};
  let txMoment = moment(children.created_datetime);
  let isIncoming = moment().subtract(10, 'seconds').isBefore(txMoment);
  let highlightClass = !i && isIncoming ? `highlight-${children.state}` : '';

  return (
    <Tr customDataTestID={`row-${i+1}`} className={highlightClass}>
      <Td>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <TransactionIcon type={children.type} style={{marginRight: '.5rem'}} />
          <ParamsLink customDataTestID="text-upload-id" query={ newQuery }>
          { children.id }
          </ParamsLink>
        </div>
      </Td>
      {children.state !== 'LOADING' &&
        <Td customDataTestID="text-step" style={{textTransform: 'capitalize'}}>{children.is_dry_run ? 'Validate' : 'Commit'}</Td>
      }
      {children.state === 'LOADING' && <Td />}
      {children.state !== 'LOADING' &&
        <Td customDataTestID="text-upload-date" >{txMoment.format(DATE_FORMAT)}</Td>
      }
      {children.state === 'LOADING' && <Td />}
      <Td customDataTestID="text-user" >{children.submitter}</Td>
      <Td customDataTestID="text-state" >{children.state === 'LOADING' ? <Spinner /> : children.state}</Td>
      <Td>
        {children.state === 'SUCCEEDED' && children.is_dry_run &&
          !children.committed_by && !children.closed &&
          <div>
            <Button
              customDataTestID="button-commit"
              disabled={projectInReview}
              onClick={() => {
                api({
                  url: `${router.params.program}/${router.params.project}/transactions/${children.id}/commit?async=true`,
                  method: 'post',
                });
                dispatch(showOptimisticPendingTransaction());
              }}
            >
              commit
            </Button>
            &nbsp;
            <Button
              customDataTestID="button-discard"
              disabled={projectInReview}
              onClick={() => {
                api({
                  url: `${router.params.program}/${router.params.project}/transactions/${children.id}/close`,
                  method: 'post',
                });
                dispatch(fetchUploadTransactions({
                  first: 10,
                  offset: 0,
                  sort: 'created_datetime',
                  order: 'desc',
                  program: router.params.program,
                  project: router.params.project,
                }));
              }}
            >
              discard
            </Button>
          </div>
        }
        {!!children.committed_by && `Committed by Transaction: ${children.committed_by}`}
        {!!children.closed && `Discarded`}
      </Td>
    </Tr>
  );
}

export default connect()(UploadTransactionsRow);
